import React, { useEffect, useState } from "react";
import { auth, db } from "./firebase";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "./DashboardLayout";

function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let unsubscribeSnapshot = null;

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (!user) {
        console.log("No user signed in.");
        setOrders([]);
        setLoading(false);
        return;
      }

      const userId = user.uid;
      const q = query(collection(db, "submissions"), where("userId", "==", userId));

      unsubscribeSnapshot = onSnapshot(
        q,
        (snapshot) => {
          const fetched = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          console.log("✅ Submissions fetched:", fetched);
          setOrders(fetched);
          setLoading(false);
        },
        (error) => {
          console.error("❌ Error fetching orders:", error);
          setOrders([]);
          setLoading(false);
        }
      );
    });

    return () => {
      if (unsubscribeSnapshot) unsubscribeSnapshot();
      unsubscribeAuth();
    };
  }, []);

  return (
    <DashboardLayout>
      {/* Mobile-only Blue Back Button */}
      <div className="sm:hidden flex justify-start px-6 pt-6">
        <button
          onClick={() => navigate("/user-dashboard")}
          className="bg-[#1976d2] text-white text-sm font-bold font-[Montserrat] px-5 py-2 rounded-md"
        >
          ← Back
        </button>
      </div>

      {!loading && orders.length > 0 && (
        <h2 className="text-xl font-bold text-center mt-4 mb-2">Your Submissions</h2>
      )}

      {loading ? (
        <p className="text-center">Loading...</p>
      ) : orders.length === 0 ? (
        <p className="text-center">No submissions found.</p>
      ) : (
        <div style={styles.grid}>
          {orders.map((order) => (
            <div
              key={order.id}
              style={styles.card}
              onClick={() => navigate(`/orders/${order.id}`)}
            >
              <div style={styles.imageBox}>
                <img
                  src={order.images?.front || ""}
                  alt="Front"
                  style={styles.image}
                />
                <img
                  src={order.images?.back || ""}
                  alt="Back"
                  style={styles.image}
                />
              </div>
              <div style={styles.info}>
                <p><strong>Card Name:</strong> {order.cardName || "N/A"}</p>
                <p><strong>Submission ID:</strong> {order.submissionId}</p>
                <p>
                  <strong>Status:</strong>{" "}
                  <span
                    style={
                      order.status === "COMPLETE"
                        ? styles.statusComplete
                        : order.status === "CANCELLED"
                        ? styles.statusCancelled
                        : styles.statusDefault
                    }
                  >
                    {order.status}
                  </span>
                </p>

                {order.status === "CANCELLED" && order.cancelReason && (
                  <p style={{ color: "red", marginTop: "5px" }}>
                    Cancellation Reason: {order.cancelReason}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </DashboardLayout>
  );
}

const styles = {
  grid: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    padding: "0 24px",
    marginTop: "0",
  },
  card: {
    display: "flex",
    flexWrap: "wrap",
    cursor: "pointer",
    border: "1px solid #fff",
    borderRadius: "8px",
    overflow: "hidden",
    backgroundColor: "#000",
    padding: "10px",
    alignItems: "center",
    transition: "background 0.2s",
    color: "#fff",
  },
  imageBox: {
    display: "flex",
    gap: "10px",
    flexShrink: 0,
  },
  image: {
    width: "120px",
    height: "auto",
    objectFit: "cover",
    borderRadius: "4px",
  },
  info: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginLeft: "20px",
    minWidth: "200px",
    textAlign: "left",
  },
  statusComplete: {
    color: "limegreen",
    fontWeight: "bold",
  },
  statusCancelled: {
    color: "red",
    fontWeight: "bold",
  },
  statusDefault: {
    color: "#fff",
  },
};

export default Orders;
